import { Checkbox } from "@kaltura/ds-react-components";
import { StyledContainer, StyledTypography, StyledTimeInput } from "./StyledComponents";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { useState, useEffect, useId } from "react";
import { parseTime, stringifyTime } from "../helper";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";

interface TimeSectionProps {
    onTimeUpdate: (startTime: number) => void;
    embedMethod?: "embed" | "oembed";
}

/**
 * start time section - sets start time param for embed code
 */
const TimeSection = (props: TimeSectionProps) => {
    const { onTimeUpdate, embedMethod } = props;

    const [isChecked, setIsChecked] = useState<boolean>(false);
    const [displayStartTime, setDisplayStartTime] = useState<string>(stringifyTime(0));
    const timeLabelId = useId();

    const sendButtonAnalytics = useButtonAnalytics();

    const toggleCheckbox = () => {
        setIsChecked((previous) => !previous);
        // send analytics
        const action = !embedMethod ? "Media Share" : embedMethod === "embed" ? "Embed" : "oEmbed";
        sendButtonAnalytics(`${action} - Start time box`, ButtonClickAnalyticsType.TOGGLE);
    };

    const updateStartTime = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDisplayStartTime(e.target.value);
    };

    useEffect(() => {
        const startTime = isChecked ? parseTime(displayStartTime) : 0;
        onTimeUpdate(startTime);
    }, [isChecked, displayStartTime]);

    return (
        <StyledContainer className="kms-ds-share-modal-time-section">
            <label>
                <Checkbox onChange={toggleCheckbox} checked={isChecked} />
                <StyledTypography variant={"body2Highlight"} id={timeLabelId}>
                    {translate("Start video at")}
                </StyledTypography>
                <StyledTimeInput
                    value={displayStartTime}
                    onChange={updateStartTime}
                    disabled={!isChecked}
                    inputProps={{ "aria-labelledby": timeLabelId }}
                />
            </label>
        </StyledContainer>
    );
};

export default TimeSection;
